import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { CommonOption } from '../common/option';
import { InitialUIElement } from '../initial-ui-element';

export const AUTOCOMPLETE_FIELD_ELEMENT_TYPE = 'autocompletefield' as const;

export const AutocompleteFieldElementType = z.literal(AUTOCOMPLETE_FIELD_ELEMENT_TYPE);

export const AutocompleteFieldParamsSchema = FieldSchema.extend({
  options: z.array(CommonOption),
});

export type TAutocompleteFieldParams = z.infer<typeof AutocompleteFieldParamsSchema>;

export const AutocompleteFieldElementSchema = InitialUIElement.extend({
  element: AutocompleteFieldElementType,
  params: AutocompleteFieldParamsSchema,
  valueDestination: z.string(),
});
